/**
 * Feature toggles that can be passed to the API
 */
export class FeatureToggles {
    public name: string;
    public isEnabled: boolean;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/agents-gateway/save-quote/feature-toggles.enum.ts